<template>
  <b-row>
    <b-col cols="12">
      <b-modal
        :visible="true"
        size="xl"
        title="Registrar salida de caja"
        ok-title="Registrar salida de caja"
        cancel-title="Cancelar"
        id="new-outgoing-payment"
        @ok="addProductModalBtn"
        @hidden="modalHidden"
      >
        <b-row>
          <b-col :cols="12">
            <div class="mt-2">
              <b-row>
                <b-form-group label="Concepto" class="col-5">
                  <b-form-input
                    type="text"
                    v-model="modalData.description"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Cantidad (EUR)" class="col-2">
                  <b-form-input
                    type="text"
                    :value="modalData.price.replace('.', ',')"
                    @change="changedPrice($event)"
                  ></b-form-input>
                </b-form-group>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'NewOutgoingPaymentModal',
  props: [],

  components: {},
  data() {
    return {
      modalData: {
        description: '',
        price: '0.00',
      },
    };
  },
  created() {},
  methods: {
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.modalData[name] = val;
    },

    changedPrice(price) {
      this.setDecimal('price', price);
    },

    modalHidden() {
      this.$emit('hidden');
    },
    addProductModalBtn(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$emit('newOutgoingPayment', this.modalData);

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing');
      });
    },
  },
  computed: {},
  mounted() {},
  updated() {
    //this.renderViews();
  },
};
</script>

<style scoped>
.canvas {
  width: 100%;
  height: 40em;
  /*background: #ebebeb;*/
}
</style>
